import { render, staticRenderFns } from "./AddModelModal.vue?vue&type=template&id=8a92b8fc&scoped=true&"
import script from "./AddModelModal.vue?vue&type=script&lang=js&"
export * from "./AddModelModal.vue?vue&type=script&lang=js&"
import style0 from "./AddModelModal.vue?vue&type=style&index=0&id=8a92b8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a92b8fc",
  null
  
)

export default component.exports